export { mpaSummaryTemplate, dpaSummaryTemplate }

const mpaSummaryTemplate = [
  { 
    id: 'title',
    form: {
      component: 'VTextField',
      bind: {
        placeholder: 'Pricing Summary Title'
      }
    },
    display: {
      component: 'h2'
    },
    value: 'MPA Pricing Summary'
  },
  { 
    id: 'first_desc',
    form: {
      component: 'VRichText',
      bind: {
        placeholder: 'Value vs. price section description',
        rows: 3
      }
    },
    display: {
      component: 'VRichTextRenderer'
    },
    value: `<p>
              Total base price to <mark>supply and install</mark> {PRODUCTS_TEXT} is {PRICE_BASE_MPA}.
            </p>
            <small><strong>*Terms: Net 30 days to value of material produced.</strong></small>`
  },
  { 
    id: 'content',
    content_id: 'mpa',
    display: {
      component: 'PricingSummary',
      bind: {
        pricingType: 'mpa'
      }
    },
    value: null
  },
  { 
    id: 'desc',
    form: {
      component: 'VRichText',
      bind: {
        placeholder: 'MPA pricing summary description',
        rows: 3
      }
    },
    display: {
      component: 'VRichTextRenderer',
      bind: {
        class: 'break-inside'
      }
    },
    value: `<p>
              When buying Mitrex solar products through the Mitrex Power Agreement 
              (MPA), Mitrex covers the costs of the solar system (including solar 
              panels, wiring, inverter, etc), and our turnkey services cover the 
              maintenance throughout the course of the contract to drastically lower 
              the up-front material costs. In addition, at a $0.00 investment, 
              Mitrex sells the energy back to the building and you receive a portion 
              of the earnings for every kWh generated throughout the duration of 
              the energy contract. The products may be eligible for tax credits 
              and government incentives.
            </p>`
  }
  // { 
  //   id: 'signature',
  //   display: {
  //     component: 'SignatureLine',
  //     bind: {
  //       sectionName: "MPA Pricing Summary",
  //       hasName: false,
  //       hasSignature: false,
  //       hasInitial: true
  //     }
  //   },
  //   value: null
  // }
]

const dpaSummaryTemplate = [
  { 
    id: 'title',
    form: {
      component: 'VTextField',
      bind: {
        placeholder: 'Pricing Summary Title'
      }
    },
    display: {
      component: 'h2'
    },
    value: 'DPA Pricing Summary'
  },
  { 
    id: 'first_desc',
    form: {
      component: 'VRichText',
      bind: {
        placeholder: 'DPA pricing summary description',
        rows: 3
      }
    },
    display: {
      component: 'VRichTextRenderer'
    },
    value: `<p>
              Total base price to <mark>supply and install</mark> {PRODUCTS_TEXT} is {PRICE_BASE_DPA}.
            </p>
            <small><strong>*Terms: Net 30 days to value of material produced.</strong></small>`
  },
  { 
    id: 'content',
    content_id: 'dpa',
    display: {
      component: 'PricingSummary',
      bind: {
        pricingType: 'dpa'
      }
    },
    value: null
  },
  { 
    id: 'desc',
    form: {
      component: 'VRichText',
      bind: {
        placeholder: 'Value vs. price section description',
        rows: 3
      }
    },
    display: {
      component: 'VRichTextRenderer'
    },
    value: `<p>
              When buying Mitrex solar products through the Direct Purchase 
              Agreement (DPA), you fully own the products and all the electricity 
              they generate. Our turnkey services are included in the price, 
              however future maintenance is not included. Full ownership will 
              result in a high return on investment and a quick payback period. 
              The products may be eligible for tax credits and government incentives.
            </p>`
  }
]